export default {
  toast_messages: {
    google_review_uploaded: 'Din anmeldelse er bekræftet. Du har optjent {{points}} point 😉',
  },
};
